<template>
<div class="consulAddDialog">
  <el-form ref="form" :model="form" label-width='110px'>
  <el-form-item label="评议内容">
    <el-input v-model="form.content" type="textarea"></el-input>
  </el-form-item>
  <el-form-item label="上传图片">
    <el-upload
      action="http://36.33.216.70:5665/api/controller/uploadVotePic/info/uploadPartyPhoto"
      list-type="picture-card"
      :on-success="handleSuccess"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :modal-append-to-body="false" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </el-form-item>
  <el-form-item>
    <div class="centerBtn">
      <el-button type="primary" @click="onSave">确定</el-button>
      <el-button @click="quxiao">取消</el-button>
    </div>
  </el-form-item>
</el-form> 
</div>
  
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
    props: ["ytid"],
    data() {
        return {
            id: this.ytid,
            dialogImageUrl: '',
            dialogVisible: false,
            value1: '',
            form: {
              photo:"",
              content: ''
            },
        }
    },
    methods: {
        onSave() {
            console.log('33333');
            console.log(this.form);
            console.log(this.id);
            post("/admin/consultComment/info/insertConsultComment",{
              ...this.form,
              consultId: this.ytid
            }).then(res => {
              console.log(res)
              this.$emit("close")
            })
        },
        getData() {
          this.form = {};
        },
        quxiao() {
          this.$emit("close")
        },
        handleRemove(file, fileList) {
        console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        handleSuccess(file, fileList) {
          console.log(file, fileList);
          console.log(file.content);
          this.form.photo = file.content;
        }
    }
}
</script>

<style lang="less" scoped>
.consulAddDialog {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.centerBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  .qubtn{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  } 
  .qubtn :hover{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  }
  .qubtn_span{
      color:#409EFF; 
      margin-top:10px
  }

}
</style>